module.exports = __webpack_public_path__ + "static/media/Inter-BoldItalic.5d543a76.woff2";